/**
 * import and init global mixins
 */

import Vue from 'vue'

import common from '../mixins/common'
import jumpTo from '../mixins/jumpTo'
import actionMx from '../mixins/actionMx'

Vue.mixin(common)
Vue.mixin(jumpTo)
Vue.mixin(actionMx)
